const relRefRegex = /\{\{< relref "(.+)\.md" >\}\}/g;

const parseWorkshopRelativeLinks = (markdown: string) => {
    return markdown.replace(relRefRegex, (substr, filename) => filename);
};

export default parseWorkshopRelativeLinks;
